import { StyleSheet, Text, View } from 'react-native'
import { colors, fontFamily } from '../tokens'

type Props = {
  name: string
  suggestedBand: string | null
  // 'included'  — block contributed to the verdict; positive green tile + band label.
  // 'checked'   — block was evaluated but didn't meet the inclusion threshold; neutral
  //               grey tile + "Checked" label. NOT in the pack; distinct from 'locked'.
  // 'locked'    — block is in the pack but hidden behind the paywall (default).
  variant?: 'included' | 'checked' | 'locked'
}

// Single evidence row — left tile (✓ / – / 🔒), label in the middle,
// right-aligned value. Matches the result card "What we found" section.
export const EvidenceBlockHeadline = ({ name, suggestedBand, variant = 'locked' }: Props) => (
  <View style={[styles.row, variant === 'locked' && styles.rowLocked]}>
    <View style={[styles.tile, variant !== 'included' && styles.tileMuted]}>
      <Text style={[styles.tileGlyph, variant !== 'included' && styles.tileGlyphMuted]}>
        {variant === 'included' ? '✓' : variant === 'checked' ? '–' : '🔒'}
      </Text>
    </View>
    <Text style={styles.name}>{name}</Text>
    <Text style={styles.value}>
      {variant === 'included'
        ? suggestedBand
          ? `Band ${suggestedBand}`
          : 'Included'
        : variant === 'checked'
          ? 'Checked'
          : 'In your pack'}
    </Text>
  </View>
)

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 13,
    paddingVertical: 14,
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  rowLocked: { opacity: 0.55 },
  tile: {
    width: 26,
    height: 26,
    borderRadius: 7,
    backgroundColor: colors.positiveSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  tileMuted: { backgroundColor: colors.surface2 },
  tileGlyph: {
    fontSize: 15,
    fontWeight: '700',
    color: colors.positive,
    lineHeight: 18,
  },
  tileGlyphMuted: { color: colors.faint, fontSize: 13 },
  name: {
    flex: 1,
    fontSize: 14.5,
    fontWeight: '500',
    color: colors.ink,
    fontFamily: fontFamily.body,
  },
  value: {
    fontSize: 13.5,
    fontWeight: '600',
    color: colors.muted,
    fontFamily: fontFamily.body,
  },
})
